import { NavLink } from "react-router-dom";

import {
  Activity,
  BarChart3,
  ClipboardList,
  CreditCard,
  FileText,
  FileSearch,
  FlaskConical,
  Receipt,
  Settings,
  Stethoscope,
  UserCog,
  Users,
  Wallet,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { visibleNavItems } from "../utils/permissions";
import { isUnderMaintenance } from "../config/maintenance";

const menuItems = [
  {
    title: "Doctors",
    path: "/doctors",
    icon: Stethoscope,
  },

  {
    title: "Services",
    path: "/services",
    icon: Settings,
  },

  {
    title: "Prescriptions",
    path: "/prescriptions",
    icon: ClipboardList,
  },

  {
    title: "Attendance",
    path: "/attendance",
    icon: Activity,
  },

  {
    title: "Employees",
    path: "/employees",
    icon: Users,
  },

  {
    title: "Payroll",
    path: "/payroll",
    icon: Wallet,
  },

  {
    title: "Expenses",
    path: "/expenses",
    icon: CreditCard,
  },

  {
    title: "Reports",
    path: "/reports",
    icon: FileText,
  },

  {
    title: "Report Extract",
    path: "/report-extract",
    icon: FileSearch,
  },

  {
    title: "Analytics",
    path: "/analytics",
    icon: BarChart3,
  },

  {
    title: "Integrations",
    path: "/integrations",
    icon: FlaskConical,
  },

  {
    title: "Import Center",
    path: "/imports",
    icon: Receipt,
  },

  {
    title: "Settings",
    path: "/settings",
    icon: UserCog,
  },
];

export default function MobileMenu() {
  const auth = useAuth();
  const visibleItems = visibleNavItems(
    auth.user,
    menuItems.map((item) => ({ ...item, label: item.title })),
  );

  return (
    <div className="space-y-4">
      {/* HEADER */}

      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-hospital-primary">
          Clinic Operations
        </p>

        <h1 className="mt-1 text-3xl font-bold text-hospital-text">
          More Menu
        </h1>

        <p className="mt-1 text-sm text-hospital-text-secondary">
          Access all clinic management tools and modules.
        </p>
      </div>

      {/* MENU GRID */}

      <div className="grid grid-cols-2 gap-4">
        {visibleItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `rounded-2xl border p-4 transition-all ${
                  isActive
                    ? "border-hospital-primary bg-hospital-primary text-white shadow-lg"
                    : "border-gray-200 bg-white text-hospital-text hover:border-hospital-primary hover:shadow-md"
                }`
              }
            >
              {({ isActive }) => (
                <div className="flex flex-col items-start gap-3">
                  <div
                    className={`rounded-xl p-3 ${
                      isActive
                        ? "bg-white/20"
                        : "bg-hospital-primary/10"
                    }`}
                  >
                    <Icon
                      className={`h-6 w-6 ${
                        isActive
                          ? "text-white"
                          : "text-hospital-primary"
                      }`}
                    />
                  </div>

                  <div>
                    <div className="flex items-center gap-1.5">
                      <h3 className="text-sm font-semibold">
                        {item.title}
                      </h3>
                      {isUnderMaintenance(item.path) && (
                        <span className={`rounded px-1 py-0.5 text-[8px] font-semibold ${
                          isActive 
                            ? "bg-white/20 text-white" 
                            : "bg-hospital-warning/10 text-hospital-warning"
                        }`}>
                          Maint.
                        </span>
                      )}
                    </div>

                    <p
                      className={`mt-1 text-xs ${
                        isActive
                          ? "text-white/80"
                          : "text-hospital-text-secondary"
                      }`}
                    >
                      {isUnderMaintenance(item.path) ? "Under maintenance" : "Open module"}
                    </p>
                  </div>
                </div>
              )}
            </NavLink>
          );
        })}
      </div>

      {/* BOTTOM SPACE FOR MOBILE NAV */}

      <div className="h-20" />
    </div>
  );
}
